module.exports = __webpack_public_path__ + "img/phone_wx.ee885f97.png";